import type { FaireProductEntity } from "../../entity_types/product";

export const p_4gltf4xddo: FaireProductEntity = {
  token: "p_4gltf4xddo",
  type: "product",
  name: 'Greeting Card "Good Friends Like Stars" Friendship Card',
  brandToken: "b_6141d8b1",
  brandName: "Quotable",
  imageUrl:
    "https://cdn.faire.com/fastly/e029640276d88aa5bbd593e31f2bf68611ad5e0db9c92b97b9b0989f2f96381c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9474ef09fb67f8119ba2237c5da6f5d46b47991ff759a72f33618215ea8641d6.png",
    "https://cdn.faire.com/fastly/b659bdb0c82f1fb57697c2be158917da863b5e8fb38c833f91a36059507bd5fe.png",
  ],
  priceDollars: 2.25,
  description:
    "5\" square greeting cards. Blank inside.\nPrinted in the USA using eco-friendly inks and responsibly sourced paper.\n• See our 48-pocket card spinner with best-seller assortment under 'collections.'\n\nFriendship, Celestial, Spiritual, Inspirational, Quotations, Quotes, Motivational, Positive, Thinking Of You, Just Because",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:08.295Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
